import { render, staticRenderFns } from "./SpotreferecnceDialog.vue?vue&type=template&id=2a74501d&scoped=true"
import script from "./SpotreferecnceDialog.vue?vue&type=script&lang=js"
export * from "./SpotreferecnceDialog.vue?vue&type=script&lang=js"
import style0 from "./SpotreferecnceDialog.vue?vue&type=style&index=0&id=2a74501d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a74501d",
  null
  
)

export default component.exports